export const required = value => !value && 'required'
